var _path, _path2, _path3, _path4, _path5, _rect, _g, _g2, _rect2, _g3, _g4, _rect3, _g5, _g6, _rect4, _g7, _g8, _path6, _path7, _path8, _path9, _path10, _path11, _g9, _g10, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFit14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 719.6 550.6",
    enableBackground: "new 0 0 719.6 550.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M489,225l-1.7,5.4l-6.4,20.8l-4.6-1.4l9.2-29.7l0.1-0.4l3.4,1c-0.1,0.6-0.2,1.3-0.2,2 C488.7,223.6,488.8,224.3,489,225z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M636.2,225l-1.7,5.4l-6.4,20.8l-4.6-1.4l9.2-29.7l0.1-0.4l3.4,1c-0.1,0.6-0.2,1.3-0.2,2C636,223.6,636,224.3,636.2,225z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M515.3,222.6c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6 c0,2.8,0.7,5.4,2.1,7.6c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C515.6,224.6,515.5,223.6,515.3,222.6 z M500.4,237.3c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7 c5.8,0,10.6,4.2,11.5,9.7c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C511,233.1,506.2,237.3,500.4,237.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M515.3,219.8c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6c0,2.8,0.7,5.4,2.1,7.6 c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C515.6,221.8,515.5,220.8,515.3,219.8z M500.4,234.5 c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7c5.8,0,10.6,4.2,11.5,9.7 c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C511,230.4,506.2,234.5,500.4,234.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M524.6,249.8l-4.6,1.4l-6.4-20.9l-1.7-5.5v0c0.1-0.7,0.2-1.3,0.2-2c0-0.7-0.1-1.3-0.2-1.9l3.4-1l0,0L524.6,249.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 97.8,
    width: 82,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2,97.8v16H6c-1.3,0-2.4-1.1-2.4-2.4v-11.3c0-1.3,1.1-2.4,2.4-2.4H14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M41.5,63.7v84.1c0,1.5-1.1,2.7-2.3,2.7h-7c-1.3,0-2.3-1.2-2.3-2.7V63.7c0-1.5,1.1-2.7,2.3-2.7h7 C40.4,61,41.5,62.2,41.5,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4,63.7v84.1c0,1.5-1,2.7-2.3,2.7h-6.8c-1.3,0-2.3-1.2-2.3-2.7V63.7c0-1.5,1-2.7,2.3-2.7h6.8 C42.3,61,43.4,62.2,43.4,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M29.9,72.3v66.9h-6.6c-1.3,0-2.3-1-2.3-2.3V74.7c0-1.3,1.1-2.3,2.3-2.3H29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9,72.3v66.9h-5.1c-1,0-1.8-1-1.8-2.3V74.7c0-1.3,0.8-2.3,1.8-2.3H29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M20.9,84.4v42.6h-4.9c-1,0-1.9-0.8-1.9-1.9V86.3c0-1,0.8-1.9,1.9-1.9H20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,84.4v42.6h-3.9c-0.8,0-1.5-0.8-1.5-1.9V86.3c0-1,0.7-1.9,1.5-1.9H20.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.6,97.8v16h8.2c1.3,0,2.4-1.1,2.4-2.4v-11.3c0-1.3-1.1-2.4-2.4-2.4H150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M123.1,63.7v84.1c0,1.5,1.1,2.7,2.4,2.7h7.1c1.3,0,2.4-1.2,2.4-2.7V63.7c0-1.5-1.1-2.7-2.4-2.7h-7.1 C124.1,61,123.1,62.2,123.1,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4,63.7v84.1c0,1.5,1,2.7,2.3,2.7h6.8c1.3,0,2.3-1.2,2.3-2.7V63.7c0-1.5-1-2.7-2.3-2.7h-6.8 C122.4,61,121.4,62.2,121.4,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M134.9,72.3v66.9h6.6c1.3,0,2.3-1,2.3-2.3V74.7c0-1.3-1.1-2.3-2.3-2.3H134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.9,72.3v66.9h5.1c1,0,1.8-1,1.8-2.3V74.7c0-1.3-0.8-2.3-1.8-2.3H134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M143.9,84.4v42.6h4.9c1,0,1.9-0.8,1.9-1.9V86.3c0-1-0.8-1.9-1.9-1.9H143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.9,84.4v42.6h3.9c0.8,0,1.5-0.8,1.5-1.9V86.3c0-1-0.7-1.9-1.5-1.9H143.9z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 99.1,
    fill: "#F37421",
    width: 82,
    height: 16
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M235.2,99.1v16H227c-1.3,0-2.4-1.1-2.4-2.4v-11.3c0-1.3,1.1-2.4,2.4-2.4H235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,65.1v84.1c0,1.5-1.1,2.7-2.3,2.7h-7c-1.3,0-2.3-1.2-2.3-2.7V65.1c0-1.5,1.1-2.7,2.3-2.7h7 C261.5,62.3,262.5,63.6,262.5,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M264.4,65.1v84.1c0,1.5-1,2.7-2.3,2.7h-6.8c-1.3,0-2.3-1.2-2.3-2.7V65.1c0-1.5,1-2.7,2.3-2.7h6.8 C263.4,62.3,264.4,63.6,264.4,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9,73.7v66.9h-6.6c-1.3,0-2.3-1-2.3-2.3V76c0-1.3,1.1-2.3,2.3-2.3H250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M250.9,73.7v66.9h-5.1c-1,0-1.8-1-1.8-2.3V76c0-1.3,0.8-2.3,1.8-2.3H250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,85.8v42.6h-4.9c-1,0-1.9-0.8-1.9-1.9V87.7c0-1,0.8-1.9,1.9-1.9H242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M242,85.8v42.6h-3.6c-0.8,0-1.4-0.8-1.4-1.9V87.7c0-1,0.6-1.9,1.4-1.9H242z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M371.6,99.1v16h8.2c1.3,0,2.4-1.1,2.4-2.4v-11.3c0-1.3-1.1-2.4-2.4-2.4H371.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,65.1v84.1c0,1.5,1.1,2.7,2.4,2.7h7.1c1.3,0,2.4-1.2,2.4-2.7V65.1c0-1.5-1.1-2.7-2.4-2.7h-7.1 C345.2,62.3,344.1,63.6,344.1,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M342.5,65.1v84.1c0,1.5,1,2.7,2.3,2.7h6.8c1.3,0,2.3-1.2,2.3-2.7V65.1c0-1.5-1-2.7-2.3-2.7h-6.8 C343.5,62.3,342.5,63.6,342.5,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,73.7v66.9h6.6c1.3,0,2.3-1,2.3-2.3V76c0-1.3-1.1-2.3-2.3-2.3H356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M356,73.7v66.9h5.1c1,0,1.8-1,1.8-2.3V76c0-1.3-0.8-2.3-1.8-2.3H356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,85.8v42.6h4.9c1,0,1.9-0.8,1.9-1.9V87.7c0-1-0.8-1.9-1.9-1.9H364.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M364.9,85.8v42.6h3.6c0.8,0,1.4-0.8,1.4-1.9V87.7c0-1-0.6-1.9-1.4-1.9H364.9z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 438.7,
    fill: "#F37421",
    width: 245.4,
    height: 16
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M331.7,436.2v20.9h10.7c1.7,0,3.1-1.4,3.1-3.1v-14.7c0-1.7-1.4-3.1-3.1-3.1H331.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.7,391.7v109.9c0,2,1.4,3.6,3.1,3.6h9.3c1.7,0,3.1-1.6,3.1-3.6V391.7c0-1.9-1.4-3.6-3.1-3.6h-9.3 C297.1,388.2,295.7,389.8,295.7,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M293.5,391.7v109.9c0,2,1.3,3.6,3,3.6h8.9c1.6,0,3-1.6,3-3.6V391.7c0-1.9-1.4-3.6-3-3.6h-8.9 C294.9,388.2,293.5,389.8,293.5,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.2,403v87.4h8.6c1.7,0,3.1-1.4,3.1-3.1v-81.2c0-1.7-1.4-3.1-3.1-3.1H311.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M311.2,403v87.4h6.7c1.3,0,2.4-1.4,2.4-3.1v-81.2c0-1.7-1.1-3.1-2.4-3.1H311.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,418.8v55.7h6.4c1.3,0,2.5-1.1,2.5-2.4v-50.8c0-1.4-1.1-2.5-2.5-2.5H322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M322.8,418.8v55.7h4.7c1,0,1.8-1.1,1.8-2.4v-50.8c0-1.4-0.8-2.5-1.8-2.5H322.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M19.4,436.2v20.9H8.7c-1.7,0-3.1-1.4-3.1-3.1v-14.7c0-1.7,1.4-3.1,3.1-3.1H19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,391.7v109.9c0,2-1.4,3.6-3.1,3.6H43c-1.7,0-3.1-1.6-3.1-3.6V391.7c0-1.9,1.4-3.6,3.1-3.6h9.3 C54,388.2,55.4,389.8,55.4,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M57.5,391.7v109.9c0,2-1.3,3.6-3,3.6h-8.9c-1.6,0-3-1.6-3-3.6V391.7c0-1.9,1.4-3.6,3-3.6h8.9 C56.2,388.2,57.5,389.8,57.5,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9,403v87.4h-8.6c-1.7,0-3.1-1.4-3.1-3.1v-81.2c0-1.7,1.4-3.1,3.1-3.1H39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M39.9,403v87.4h-6.7c-1.3,0-2.4-1.4-2.4-3.1v-81.2c0-1.7,1.1-3.1,2.4-3.1H39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,418.8v55.7h-6.4c-1.3,0-2.5-1.1-2.5-2.4v-50.8c0-1.4,1.1-2.5,2.5-2.5H28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M28.2,418.8v55.7h-4.7c-1,0-1.8-1.1-1.8-2.4v-50.8c0-1.4,0.8-2.5,1.8-2.5H28.2z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 419.5,
    y: 438.7,
    width: 245.4,
    height: 16
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M695.6,436.2v20.9h10.7c1.7,0,3.1-1.4,3.1-3.1v-14.7c0-1.7-1.4-3.1-3.1-3.1H695.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M659.6,391.7v109.9c0,2,1.4,3.6,3.1,3.6h9.3c1.7,0,3.1-1.6,3.1-3.6V391.7c0-1.9-1.4-3.6-3.1-3.6h-9.3 C661,388.2,659.6,389.8,659.6,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.5,391.7v109.9c0,2,1.3,3.6,3,3.6h8.9c1.6,0,3-1.6,3-3.6V391.7c0-1.9-1.4-3.6-3-3.6h-8.9 C658.8,388.2,657.5,389.8,657.5,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M675.1,403v87.4h8.6c1.7,0,3.1-1.4,3.1-3.1v-81.2c0-1.7-1.4-3.1-3.1-3.1H675.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.1,403v87.4h6.7c1.3,0,2.4-1.4,2.4-3.1v-81.2c0-1.7-1.1-3.1-2.4-3.1H675.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M686.8,418.8v55.7h6.4c1.3,0,2.5-1.1,2.5-2.4v-50.8c0-1.4-1.1-2.5-2.5-2.5H686.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.8,418.8v55.7h4.7c1,0,1.8-1.1,1.8-2.4v-50.8c0-1.4-0.8-2.5-1.8-2.5H686.8z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.3,436.2v20.9h-10.7c-1.7,0-3.1-1.4-3.1-3.1v-14.7c0-1.7,1.4-3.1,3.1-3.1H383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M419.3,391.7v109.9c0,2-1.4,3.6-3.1,3.6h-9.3c-1.7,0-3.1-1.6-3.1-3.6V391.7c0-1.9,1.4-3.6,3.1-3.6h9.3 C417.9,388.2,419.3,389.8,419.3,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.4,391.7v109.9c0,2-1.3,3.6-3,3.6h-8.9c-1.6,0-3-1.6-3-3.6V391.7c0-1.9,1.4-3.6,3-3.6h8.9 C420.1,388.2,421.4,389.8,421.4,391.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M403.8,403v87.4h-8.6c-1.7,0-3.1-1.4-3.1-3.1v-81.2c0-1.7,1.4-3.1,3.1-3.1H403.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.8,403v87.4h-6.7c-1.3,0-2.4-1.4-2.4-3.1v-81.2c0-1.7,1.1-3.1,2.4-3.1H403.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M392.1,418.8v55.7h-6.4c-1.3,0-2.5-1.1-2.5-2.4v-50.8c0-1.4,1.1-2.5,2.5-2.5H392.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.1,418.8v55.7h-4.7c-1,0-1.8-1.1-1.8-2.4v-50.8c0-1.4,0.8-2.5,1.8-2.5H392.1z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M540,326.3l-12.4-34.7l-7.7-21.5l-5.9-16.6c-1.1-3,0.5-6.4,3.5-7.5l7.5-2.7c3-1.1,6.4,0.5,7.5,3.5l5.9,16.5 c0,0,0,0,0,0.1l20.1,56.1c1.1,3-0.5,6.4-3.5,7.4l-7.5,2.7C544.4,330.9,541.1,329.3,540,326.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M523.1,263.5l8.7-3.1c2.7-1,5.7,0.5,6.6,3.1l20.3,56.7c1,2.7-0.5,5.7-3.1,6.6l-8.7,3.1c-2.7,1-5.7-0.5-6.6-3.1l-20.3-56.7 C519,267.5,520.4,264.5,523.1,263.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M123.5,248.9c0,0,0,67.5,0,72c0,4.5-0.9,10.8-2.5,12c-1.7,1.2-8.1,3-21.5,3s-19.8-1.8-21.5-3 c-1.7-1.2-2.5-7.5-2.5-12c0-4.5,0-72,0-72s0.3-2.3,3-6.7c2.7-4.4,4.2-8.7-1.4-11.8c0,0-1.5-0.6-1.5-2.4c0-1.9-0.5-5,2-6.6 c0,0,10.8-2.1,21.8-2.1c11,0,21.8,2.1,21.8,2.1c2.5,1.6,2,4.7,2,6.6c0,1.9-1.5,2.4-1.5,2.4c-5.5,3.1-4.1,7.3-1.4,11.8 C123.1,246.6,123.5,248.9,123.5,248.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.9,220.2c0,1-1.6,1.2-1.6,1.2s-10.8-2.1-21.8-2.1c-11,0-21.8,2.1-21.8,2.1s-1.6-0.2-1.6-1.2c0-1,1.1-11.8,1.1-11.8 s2.1-4,14.8-5.5c0,0,1.2-0.1,1-7.1h-2.1c0,0,0.1-2.1,8.6-2.1s8.7,2.1,8.7,2.1h-2.3c-0.2,7,1,7.1,1,7.1c12.7,1.4,14.8,5.5,14.8,5.5 S122.9,219.2,122.9,220.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5,248.9c0,0,0,67.5,0,72c0,4.5-0.9,10.8-2.5,12c-1.7,1.2-8.1,3-21.5,3s-19.8-1.8-21.5-3c-1.7-1.2-2.5-7.5-2.5-12 c0-4.5,0-72,0-72s0.3-2.3,3-6.7c2.7-4.4,4.2-8.7-1.4-11.8c0,0-1.5-0.6-1.5-2.4c0-1.9-0.5-5,2-6.6c0,0,10.8-2.1,21.8-2.1 c11,0,21.8,2.1,21.8,2.1c2.5,1.6,2,4.7,2,6.6c0,1.9-1.5,2.4-1.5,2.4c-5.5,3.1-4.1,7.3-1.4,11.8C55.2,246.6,55.5,248.9,55.5,248.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M55,220.2c0,1-1.6,1.2-1.6,1.2s-10.8-2.1-21.8-2.1c-11,0-21.8,2.1-21.8,2.1s-1.6-0.2-1.6-1.2 c0-1,1.1-11.8,1.1-11.8s2.1-4,14.8-5.5c0,0,1.2-0.1,1-7.1h-2.1c0,0,0.1-2.1,8.6-2.1s8.7,2.1,8.7,2.1H38c-0.2,7,1,7.1,1,7.1 c12.7,1.4,14.8,5.5,14.8,5.5S54.9,219.2,55,220.2z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M280.6,296.6c0,9.3-3,18-8.2,24.9c0,0-12.5,5.2-33.8,5.2c-21.3,0-33.8-5.2-33.8-5.2 c-5.2-7-8.2-15.6-8.2-24.9c0-9.6,3.2-18.5,8.7-25.5c1.6-2.1,3.3-4,5.3-5.7c7.4-6.7,17.3-10.8,28.1-10.8c10.8,0,20.7,4.1,28.1,10.8 c1.9,1.7,3.7,3.6,5.3,5.7C277.4,278.1,280.6,287,280.6,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.2,275.8c-1.6-2.1-6.5-8.7-8.4-10.5c0,0,38.4-40.5-28.1-40.5c-66.5,0-28.1,40.5-28.1,40.5c-1.9,1.7-6.5,6.6-8,8.7 c0,0-48.2-60.1,36.2-60.1S275.2,275.8,275.2,275.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.6,296.6c0,9.3-3,18-8.2,24.9c0,0-12.5,5.2-33.8,5.2c-21.3,0-33.8-5.2-33.8-5.2c-5.2-7-8.2-15.6-8.2-24.9 c0-9.6,3.2-18.5,8.7-25.5c1.6-2.1,3.3-4,5.3-5.7c7.4-6.7,17.3-10.8,28.1-10.8c10.8,0,20.7,4.1,28.1,10.8c1.9,1.7,3.7,3.6,5.3,5.7 C391.3,278.1,394.6,287,394.6,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M389.1,275.8c-1.6-2.1-6.5-8.7-8.4-10.5c0,0,38.4-40.5-28.1-40.5c-66.5,0-28.1,40.5-28.1,40.5 c-1.9,1.7-6.5,6.6-8,8.7c0,0-48.2-60.1,36.2-60.1S389.1,275.8,389.1,275.8z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M461.9,326.2l12.4-34.7l7.7-21.5l5.9-16.6c1.1-3-0.5-6.4-3.5-7.5l-7.5-2.7c-3-1.1-6.4,0.5-7.5,3.5l-5.9,16.5 c0,0,0,0,0,0.1l-20.1,56.1c-1.1,3,0.5,6.4,3.5,7.4l7.5,2.7C457.5,330.8,460.9,329.2,461.9,326.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M478.9,263.4l-8.7-3.1c-2.7-1-5.7,0.5-6.6,3.1l-20.3,56.7c-1,2.7,0.5,5.7,3.1,6.6l8.7,3.1c2.7,1,5.7-0.5,6.6-3.1l20.3-56.7 C483,267.4,481.5,264.4,478.9,263.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M662.6,222.6c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6c0,2.8,0.7,5.4,2.1,7.6 c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C662.9,224.6,662.8,223.6,662.6,222.6z M647.6,237.3 c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7c5.8,0,10.6,4.2,11.5,9.7 c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C658.2,233.1,653.4,237.3,647.6,237.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M662.6,219.8c-1.4-7-7.5-12.2-14.9-12.2c-7.5,0-13.7,5.4-15,12.6c-0.2,0.9-0.2,1.7-0.2,2.6 c0,2.8,0.7,5.4,2.1,7.6c2.6,4.5,7.5,7.6,13.2,7.6c5.6,0,10.6-3.1,13.2-7.7c1.3-2.2,2-4.8,2-7.6C662.9,221.8,662.8,220.8,662.6,219.8 z M647.6,234.5c-5.7,0-10.4-4.1-11.5-9.5c-0.1-0.7-0.2-1.5-0.2-2.2c0-0.7,0.1-1.3,0.2-2c0.9-5.5,5.7-9.7,11.5-9.7 c5.8,0,10.6,4.2,11.5,9.7c0.1,0.6,0.2,1.3,0.2,1.9c0,0.7-0.1,1.4-0.2,2v0C658.2,230.4,653.4,234.5,647.6,234.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M671.9,249.8l-4.6,1.4l-6.4-20.9l-1.7-5.5v0c0.1-0.7,0.2-1.3,0.2-2c0-0.7-0.1-1.3-0.2-1.9l3.4-1l0,0 L671.9,249.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M687.2,326.3l-12.4-34.7l-7.7-21.5l-5.9-16.6c-1.1-3,0.5-6.4,3.5-7.5l7.5-2.7c3-1.1,6.4,0.5,7.5,3.5l5.9,16.5c0,0,0,0,0,0.1 l20.1,56.1c1.1,3-0.5,6.4-3.5,7.4l-7.5,2.7C691.6,330.9,688.3,329.3,687.2,326.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M670.3,263.5l8.7-3.1c2.7-1,5.7,0.5,6.6,3.1l20.3,56.7c1,2.7-0.5,5.7-3.1,6.6l-8.7,3.1 c-2.7,1-5.7-0.5-6.6-3.1l-20.3-56.7C666.2,267.5,667.6,264.5,670.3,263.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M609.2,326.2l12.4-34.7l7.7-21.5l5.9-16.6c1.1-3-0.5-6.4-3.5-7.5l-7.5-2.7c-3-1.1-6.4,0.5-7.5,3.5l-5.9,16.5c0,0,0,0,0,0.1 l-20.1,56.1c-1.1,3,0.5,6.4,3.5,7.4l7.5,2.7C604.8,330.8,608.1,329.2,609.2,326.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M626.1,263.4l-8.7-3.1c-2.7-1-5.7,0.5-6.6,3.1l-20.3,56.7c-1,2.7,0.5,5.7,3.1,6.6l8.7,3.1 c2.7,1,5.7-0.5,6.6-3.1l20.3-56.7C630.2,267.4,628.8,264.4,626.1,263.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M503.8,135.5c0,0-37.7-26.5-44.5-43.2c6.1-14.9,18.4-26.6,33.7-32C493,60.3,489.2,104.7,503.8,135.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M568.3,113.8c0,2.9-0.2,5.7-0.6,8.5c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5c-1,0.7-1.9,1.4-2.9,2 c-8.8,5.6-19.3,8.9-30.5,8.9c-31.3,0-56.6-25.3-56.6-56.6c0-7.6,1.5-14.8,4.2-21.5c6.8,16.7,44.5,43.2,44.5,43.2 C489.2,104.7,493,60.3,493,60.3c5.8-2,12.1-3.2,18.7-3.2C542.9,57.2,568.3,82.5,568.3,113.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M567.7,122.2c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5c-13.6-18.9-17.3-77.1-17.3-77.1 C538.2,98,553.5,111.7,567.7,122.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M651,135.5c0,0-37.7-26.5-44.5-43.2c6.1-14.9,18.4-26.6,33.7-32C640.2,60.3,636.5,104.7,651,135.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37421",
    d: "M715.5,113.8c0,2.9-0.2,5.7-0.6,8.5c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5 c-1,0.7-1.9,1.4-2.9,2c-8.8,5.6-19.3,8.9-30.5,8.9c-31.3,0-56.6-25.3-56.6-56.6c0-7.6,1.5-14.8,4.2-21.5 c6.8,16.7,44.5,43.2,44.5,43.2c-14.5-30.8-10.8-75.2-10.8-75.2c5.8-2,12.1-3.2,18.7-3.2C690.2,57.2,715.5,82.5,715.5,113.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M714.9,122.2c-0.7,4.4-1.8,8.7-3.5,12.7c-4,9.8-10.6,18.3-19.1,24.5c-13.6-18.9-17.3-77.1-17.3-77.1 C685.4,98,700.7,111.7,714.9,122.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFit14);
export default __webpack_public_path__ + "static/media/iconsFit-14.ab2d4fc5f1e07c2789253f373ffbeae1.svg";
export { ForwardRef as ReactComponent };